$(document).ready(function () {

    // Sort change
    $('.select_sort').on('change', function () {
        applyFilterSort();
    });

    // Checkbox filter change
    $('.filter-item-checkbox').on('change', function () {
        applyFilterSort();
    });

    // Price range change
    $('.price-min, .price-max').on('change', function () {
        applyFilterSort();
    });

});


/* ===============================
   Main Filter Function
================================ */
function applyFilterSort() {

    var sort = $('.select_sort').val();
    var coll = $('.collection_name').val();

    // Fix collection handle
    if (coll === 'products') {
        coll = 'all';
    }

    /* -----------------------------
       Build Checkbox Filters
    ----------------------------- */
    var filters = $('.filter-item-checkbox:checked').map(function () {
        return $(this).data('option') + '=' + encodeURIComponent($(this).val());
    }).get();


    /* -----------------------------
       Price Range
    ----------------------------- */
    var minPrice = $('.price-min').val();
    var maxPrice = $('.price-max').val();

    if (minPrice) {
        filters.push('filter.v.price.gte=' + minPrice);
    }

    if (maxPrice) {
        filters.push('filter.v.price.lte=' + maxPrice);
    }


    /* -----------------------------
       Sort
    ----------------------------- */
    if (sort) {
        filters.push('sort_by=' + sort);
    }


    /* -----------------------------
       Build URL
    ----------------------------- */
    var baseUrl = '/collections/' + coll;
    var queryString = filters.length ? '?' + filters.join('&') : '';

    var finalUrl = baseUrl + queryString;


    /* -----------------------------
       Update Counter
    ----------------------------- */
    $('.added_filter').text($('.filter-item-checkbox:checked').length);


    /* -----------------------------
       Push URL
    ----------------------------- */
    window.history.pushState({}, '', finalUrl);


    /* -----------------------------
       Load Products
    ----------------------------- */
    filter_update(finalUrl);

}


/* ===============================
   AJAX Product Load
================================ */
function filter_update(url) {

    fetch(url)
        .then(res => res.text())
        .then(data => {

            var newProducts = $(data).find('.collection-product-wrap');

            $('.collection-product-wrap').replaceWith(newProducts);

        })
        .catch(err => {
            console.error('Filter Error:', err);
        });

}


/* ===============================
   Accordion Toggle
================================ */
function filterActive(e, el) {

    $(el).next().slideToggle();
    $(el).toggleClass('inactive');

}


/* ===============================
   Back / Forward Support
================================ */
window.addEventListener('popstate', function () {

    filter_update(location.pathname + location.search);

});
